import React from "react";
import { Link } from "react-router-dom";
import { CAlert, CButton } from "@coreui/react";

/**
 * Distinguishes "iikoCloud just isn't configured for this server" (a setup
 * step, not a failure) from "iikoCloud/upstream answered with an error"
 * (a real, possibly transient, failure) — the two looked identical to users
 * before (see the "в чем проблема?" confusion this was built to fix), even
 * though one needs a settings link and the other needs a retry button.
 */
export default function CloudStatusState({ message, onRetry }) {
  const text = String(message || "Не удалось получить данные.");
  const notConfigured = /не подключ/i.test(text);

  if (notConfigured) {
    return (
      <CAlert color="secondary" className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-0">
        <span>{text}</span>
        <CButton as={Link} to="/settings" size="sm" color="primary" variant="outline">
          Настроить iikoCloud
        </CButton>
      </CAlert>
    );
  }

  return (
    <CAlert color="warning" className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-0">
      <span>{text}</span>
      {onRetry && (
        <CButton size="sm" color="warning" variant="outline" onClick={onRetry}>
          Повторить
        </CButton>
      )}
    </CAlert>
  );
}
